import EssenceAnimatedButton from '../../../components/essence/button/animated-button';
import Header from '../../../shared/components/header/page';
import Content from '../../../shared/components/content/page';
import { useParams, useNavigate } from 'react-router-dom';
import accountService from '../../../shared/services/account-service';
import getMemberType from '../../../secure/circle-details/member-type';
import { useCircleQueries } from '../../../shared/tanstack/circle/queries';
import EssenceAnimatedRadio from '../../../components/essence/radio/animated-radio';
import { useQuery } from '@tanstack/react-query';
import { useExpenseQueries } from '../../../shared/tanstack/expenses/queries';
import { InvalidCircleIdError } from '../../../shared/models/errors/invalid-circle-id-error';
import { InvalidAccessTokenError } from '../../../shared/models/errors/invalid-access-token-error';

const AddEditSettlementStep1 = () => {
	const { id: circleId } = useParams();
	const navigate = useNavigate();

	if (!circleId) {
		throw new InvalidCircleIdError();
	}

	const { circleQuery } = useCircleQueries();
	const { data: circle } = useQuery(circleQuery(circleId));

	const { expensesSummaryQuery } = useExpenseQueries();
	const { data: expensesSummary } = useQuery(expensesSummaryQuery(circleId));

	const { participantsQuery } = useCircleQueries();
	const { data: participants } = useQuery(participantsQuery(circleId));

	let member: string | undefined;
	if (circle) {
		const memberType = getMemberType(circle.type);
		if (memberType) {
			member = memberType.title;
		}
	}

	const account = accountService.getAccount();
	if (!account) {
		throw new InvalidAccessTokenError();
	}
	const loggedInUserId: string | undefined = account.id;

	const goToSettlementDetail = (e: React.SyntheticEvent) => {
		e.preventDefault();
		navigate(`/secure/circles/${circleId}/add-settlement/settlement-detail`);
	};

	const _findParticipant = (userId: string) => {
		if (participants) {
			const filteredParticipant = participants.find(x => x.id == userId);
			return filteredParticipant;
		}
		return;
	};
	if (expensesSummary) {
		return (
			<>
				{member && <Header title={member} subtitle={`Select the ${member} to settle with.`} />}
				<Content>
					{expensesSummary.length > 0 && (
						<div className="mb-6 gap-20 items-center">
							{expensesSummary.map((summary, i) => (
								<EssenceAnimatedRadio
									defaultChecked={i === 0}
									key={summary.creditorId}
									text={
										summary.creditorId !== loggedInUserId
											? `Paid ${
													_findParticipant(
														summary.creditorId !== loggedInUserId
															? summary.creditorId
															: summary.debtorId,
													)?.name ?? ''
												} ${summary.currency}${summary.amount.toString()}`
											: `Collected from ${
													_findParticipant(
														summary.creditorId !== loggedInUserId
															? summary.creditorId
															: summary.debtorId,
													)?.name ?? ''
												} ${summary.currency}${summary.amount.toString()}`
									}
									name="creditors"
									value={summary.creditorId}
								/>
							))}

							<div className="mt-6"></div>
							<EssenceAnimatedButton name="next" onClick={goToSettlementDetail} />
						</div>
					)}
				</Content>
			</>
		);
	}
};

export default AddEditSettlementStep1;
